export default "__VITE_ASSET__CH9Kxya8__"